import React from 'react';
import { getSettingsClass } from '~/utils/helpers';

interface NumbersProps {
  block: {
    settings: Settings;
    _template: string;
    css_class_name: string;
    background_color: string;
    value_font_size?: number;
    value_line_height?: number;
    text_font_size?: number;
    text_line_height?: number;
    text_alignment?: React.CSSProperties['textAlign'];
    container_alignment?: string;
    column_gap?: number;
    columns: {
      icon: string;
      text: string;
      value: string;
      divider_position?: number;
    }[];
  };
  siteVars: {
    [key: string]: string;
  };
}

const Numbers = ({ block, siteVars }: NumbersProps) => {
  let numbersBackgroundColorClass = '';
  if (block.background_color === 'White') {
    numbersBackgroundColorClass = 'bg-white';
  }

  const bg_class = block.background_color === 'White' ? 'bg-white' : '';
  const iconsClass = block.columns.some(column => column.icon)
    ? 'has-icons'
    : '';

  const settingsClass = getSettingsClass(block.settings);

  return (
    <section
      className={`block ${block._template || ''} ${block.css_class_name || ''} ${bg_class || ''} ${iconsClass} ${settingsClass}`}
    >
      <div
        className='container'
        style={{
          paddingLeft: block.container_alignment === 'left' ? 0 : '',
          paddingRight: block.container_alignment === 'right' ? 0 : '',
        }}
      >
        <ul
          className={iconsClass}
          style={{
            justifyContent:
              block.container_alignment === 'left'
                ? 'flex-start'
                : block.container_alignment === 'right'
                  ? 'flex-end'
                  : 'space-evenly',
            gap: block.column_gap ? `${block.column_gap}rem` : '',
          }}
        >
          {block.columns.map((column, index) => {
            /**
             * Legacy: Reference to siteVars could be removed, but it is kept for backward compatibility.
             * Unless the editors go through all the pages and change the value field to text field with brackets.
             *
             * The column.value could be in two formats:
             * 1. <b>SomeText {column.value}</b> - will render HTML with the value from siteVars
             * 2. column.value - will render the value from siteVars
             */
            const siteVar = Object.entries(siteVars).find(
              ([varKey]) => varKey === column.value
            ) || [null, column.value];
            const legacyColumnValue_couldBeUpdated =
              siteVar && siteVar[1] ? siteVar[1] : column.value;

            return (
              <li key={index}>
                {index !== 0 && (
                  <span
                    style={{
                      left: column.divider_position
                        ? `${column.divider_position}px`
                        : block.column_gap
                          ? `-${block.column_gap / 2}rem`
                          : '-26px',
                    }}
                  ></span>
                )}
                {column.icon && (
                  <img
                    src={column.icon}
                    alt={column.text}
                    title={column.text}
                  />
                )}
                <div className='numbers-wr'>
                  {column.value && (
                    <div
                      className='value'
                      style={{
                        fontSize: block.value_font_size
                          ? `${block.value_font_size}rem`
                          : '',
                        lineHeight: block.value_line_height
                          ? block.value_line_height
                          : '',
                        textAlign: block.text_alignment
                          ? block.text_alignment
                          : 'center',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: legacyColumnValue_couldBeUpdated,
                      }}
                    />
                  )}
                  {column.text && (
                    <div
                      className='text'
                      style={{
                        fontSize: block.text_font_size
                          ? `${block.text_font_size}rem`
                          : '',
                        lineHeight: block.text_line_height
                          ? block.text_line_height
                          : '',
                        textAlign: block.text_alignment
                          ? block.text_alignment
                          : 'center',
                      }}
                      dangerouslySetInnerHTML={{ __html: column.text }}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Numbers;
